import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import WidgetSquarePlaceholder from './WidgetSquarePlaceholder';
import { ticketingService } from 'features/inventory/ticketing/TicketingService';

function TicketToApprove() {
  const { t } = useTranslation();
  const [counter, setCounter] = useState(undefined);

  useEffect(() => {
    ticketingService.getTechnicianCreated(0, 0).then((res) => {
      setCounter(res.count);
    });
  }, []);

  return counter !== undefined ? (
    <div className="w-full flex flex-col justify-center items-center px-1">
      {counter > 0 && (
        <>
          <TaskAltIcon fontSize="large" color="warning" />
          <span className="text-center">{t(`dashboard.ticket.to-be-approve-message`)}</span>
          <NavLink to={'/tenant/equipments/ticketing/technician-created'}>
            <Button color="warning">{t(`dashboard.ticket.to-approve-view-all`)}</Button>
          </NavLink>
        </>
      )}
      {counter === 0 && (
        <>
          <TaskAltIcon fontSize="large" color="success" />
          <span className="text-center">{t(`dashboard.ticket.already-approved-message`)}</span>
          <NavLink to={'/tenant/equipments/ticketing'}>
            <Button color="success">{t(`dashboard.ticket.go`)}</Button>
          </NavLink>
        </>
      )}
    </div>
  ) : (
    <>
      {counter}
      <WidgetSquarePlaceholder />
    </>
  );
}

export default TicketToApprove;
